module.exports = __webpack_public_path__ + "img/1.6abaae57.jpg";